import {getDeviceId} from '../utils/readCookie'
import { getItem, itemType } from 'MMT-UI/storages/client/localStorage';

export default function PDTInfo() {
    const locus_data = sessionStorage.getItem('locus_info')
    const locus_info = locus_data !== null ? JSON.parse(locus_data) : {
        source_locus_code: null,
        source_locus_type: "CITY",
        source_locus_city_code: null,
        source_locus_station_code: null,
        destination_locus_code: null,
        destination_locus_type: null,
        destination_locus_city_code: "CITY",
        destination_locus_station_code: null,
        destination_locus_station_name: null,
    }

    const tracking_params = {
        ...collectPDTInfo(),
        trackingId: null,
        userIP: null,
        requestingServerIP: null,
        respondingServerIP: null,
        bookMode: "D",
        marketing_cloud_id: null,
        login_channel: null,
    }

    const device_info = {
        ...fetchDeiveInfo(),
        operating_system: getOS(),
        operating_system_version: "NA",
        model: null,
        id: null,
        carrier: null,
        latitude: null,
        longitude: null,
        connection_type: "WiFi",
        application_version: null,
        geo_city: null,
        user_agent: null,
        flavour: "desktop",
        device_id: getDeviceId() || 'rails-dweb',
        device_type: 'desktop',
        lang: null
    }

    const pdtInfo = {
        locus_info, tracking_params, device_info
    }
    return pdtInfo
}

const collectPDTInfo = () => {
    const data = getItem('auths', { isPiiData: true, shouldParseJson: true }, itemType.ES);
    let email_communication_id = null, mobile_communication_id = null, is_email_verified = null, is_mobile_verified = null, mobile_country_code = null
    if (!data) {
        return {
            is_logged_in: false,
            uuid: null,
            profile_type: null,
            email_communication_id: null,
            mobile_communication_id: null,
            is_email_verified: null,
            is_mobile_verified: null,
            email_id: null,
            mobile_country_code: null
        }
    }
    else {
        const { profileType, userDetails: { extendedUser: { loginInfoList, uuid, primaryEmailId } } } = data[0]
        loginInfoList.forEach(element => {
            if (element.loginType == 'EMAIL') {
                email_communication_id = element.loginId
                is_email_verified = element.verified
            }
            else {
                mobile_communication_id = element.loginId
                is_mobile_verified = element.verified
                mobile_country_code = element.mobile_country_code
            }
        });
        return {
            is_logged_in: true,
            uuid,
            profile_type: profileType,
            email_communication_id,
            mobile_communication_id,
            is_email_verified,
            is_mobile_verified,
            email_id: primaryEmailId,
            mobile_country_code
        }
    }
}

const fetchDeiveInfo = () => {
    const data = localStorage.getItem('device_info')
    if (data === null) {
        let ua = navigator.userAgent;
        let tem;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        const browserDetails = { browser: M[0] || null, browser_version: M[1] || null }
        return browserDetails
    }
}

function getOS() {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }
    else {
        os = null
    }

    return os;
}